export default __webpack_public_path__ + "static/core-values_empower-235f2ddaf682e3dc8fa3b41b2dbde1c9.svg";